"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolyjuiceWallet = void 0;
const ethers_1 = require("ethers");
const properties_1 = require("@ethersproject/properties");
const address_1 = require("@ethersproject/address");
const base_1 = require("@polyjuice-provider/base");
const logger_1 = require("@ethersproject/logger");
const bytes_1 = require("@ethersproject/bytes");
const logger = new logger_1.Logger("Polyjuice-Wallet/0.0.1");
class PolyjuiceWallet extends ethers_1.Wallet {
    constructor(privateKey, polyjuiceConfig, provider) {
        super(privateKey, provider);
        const godwokerOption = {
            godwoken: {
                rollup_type_hash: polyjuiceConfig.rollupTypeHash,
                eth_account_lock: {
                    code_hash: polyjuiceConfig.ethAccountLockCodeHash,
                    hash_type: "type",
                },
            },
        };
        if (!polyjuiceConfig.web3Url)
            throw new Error("should provide web3 rpc url in polyjuiceConfigs.");
        this.godwoker = new base_1.Godwoker(polyjuiceConfig.web3Url, godwokerOption);
        this.abi = new base_1.Abi(polyjuiceConfig.abiItems || []);
    }
    setAbi(abiItems) {
        this.abi = new base_1.Abi(abiItems);
    }
    signTransaction(transaction) {
        return properties_1.resolveProperties(transaction).then(async (tx) => {
            await this.godwoker.init();
            if (tx.from != null) {
                if (address_1.getAddress(tx.from) !== this.address) {
                    logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                    throw new Error(`transaction from address mismatch, wallet address: ${this.address}, transaction address: ${transaction.from}`);
                }
            }
            // use godwoken-polyjuice transaction signing method
            // (which is different tx type and use a message signing)
            // to sign transaction.
            const t = {
                from: tx.from,
                to: base_1.formalizeEthToAddress(tx.to),
                value: bytes_1.hexlify(tx.value || 0),
                data: bytes_1.hexlify(tx.data),
                gas: bytes_1.hexlify(tx.gasLimit || base_1.POLY_MAX_TRANSACTION_GAS_LIMIT),
                gasPrice: bytes_1.hexlify(tx.gasPrice || base_1.POLY_MIN_GAS_PRICE),
            };
            const that = this;
            const signingMethod = function (message) {
                return bytes_1.joinSignature(that._signingKey().signDigest(message));
            };
            try {
                return await base_1.buildSendTransaction(this.abi, this.godwoker, t, signingMethod.bind(that));
            }
            catch (error) {
                logger.throwError(error.message);
                throw new Error(error.message);
            }
        });
    }
}
exports.PolyjuiceWallet = PolyjuiceWallet;
//# sourceMappingURL=wallet-signer.js.map